<template>
  <section class="search-field" v-if="showSearch && !getSeller">
    <div class="w-100 text-center">
      <h2 class="mb-4">Etsi alueesi myyjä</h2>
    </div>
    <div class="autocomplete-search-input-wrapper">
      <AutocompleteInput
        v-if="!getSeller && locale !== 'sv'"
        key="oma-myyja"
        :loading="loading"
        :error="error"
        placeholder="Katuosoite"
        @selected="getAddress"
      />
    </div>
  </section>
  <section :class="{ 'two-column': twoColumn }" class="row">
    <div
      v-if="!getSeller || showTwo"
      :class="{
        'col-md-6': showTwo,
        'col-12': showTwo || !getSeller,
        'extra-text': extraText,
      }"
      class="phone-information-wrapper"
    >
      <div class="phone-information row g-0">
        <div class="col-12">
          <h2 v-if="!extraText">
            {{
              "Soilfoodin maatalousmyynti palvelee valtakunnallisesti numerossa:"
            }}
          </h2>
          <h2 v-else-if="extraText">
            {{
              "Voit myös soittaa myynnin vaihteeseen, ja ohjaamme sinut oikealle henkilölle"
            }}
          </h2>
        </div>
        <div class="col-12">
          <a class="plausible-event-name=Puhelinsoitto" href="tel:020 144 1020">
            020 144 1020
          </a>
        </div>
      </div>
    </div>
    <div
      v-if="getSeller || showTwo"
      :class="{ 'col-md-6': showTwo, 'col-12': showTwo || getSeller }"
      class="seller-information-wrapper"
    >
      <div class="seller-information row g-0">
        <div :class="{ 'col-lg-6': !twoColumn }" class="col-12">
          <h2>
            {{ t("questionsTitle") }}
          </h2>
        </div>
        <div :class="{ 'col-lg-6': !twoColumn }" class="col-12">
          <YourSeller />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import YourSeller from "@/shared/components/YourSeller";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { useI18n } from "vue-i18n";
import AutocompleteInput from "@/shared/components/AutocompleteInput.vue";
import { SET_ADDRESS, SET_SELLER, UPDATE_PROFILE } from "@/store/constants";
import { get } from "@vueuse/core";
import { getAddressInfo } from "@/shared/helpers";

export default {
  name: "SellerInformation",
  components: {
    AutocompleteInput,
    YourSeller,
  },
  setup() {
    const { t, locale } = useI18n();

    return { t, locale };
  },
  data() {
    return {
      error: false,
      loading: false,
    };
  },
  props: {
    twoColumn: {
      type: Boolean,
      default: false,
    },
    extraText: {
      type: Boolean,
      default: false,
    },
    showSearch: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    ...mapMutations({
      setAddress: SET_ADDRESS,
      setSeller: SET_SELLER,
    }),
    ...mapActions({
      updateProfile: UPDATE_PROFILE,
    }),
    getAddress: async function ({ fromEvent, input, autocomplete }) {
      this.error = false;
      this.loading = true;
      const auto = get(autocomplete);
      const place = auto.getPlace();
      const inEl = get(input);

      const locationObject = await getAddressInfo(place, inEl, fromEvent);

      const { placeObject } = locationObject;

      if (!placeObject || (!placeObject.postal_code && !placeObject.locality)) {
        this.error = true;
        this.loading = false;
        return;
      }

      if (inEl.value) placeObject.addressLine = inEl.value;

      placeObject.geometryLocation = locationObject.geometryLocation;

      const updateResult = await this.updateProfile({
        placeObject,
        ignoreSellerError: false,
      });

      if (!updateResult) {
        this.error = true;
        this.loading = false;
        return;
      }

      this.loading = false;
    },
  },
  computed: {
    ...mapGetters(["getSeller"]),
    showTwo: function () {
      return this.getSeller && this.twoColumn;
    },
  },
};
</script>

<style lang="scss" scoped>
.seller-information,
.phone-information,
.search-field {
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 2rem 1.5rem;
  width: 100%;
  // height: 100%;
  background-color: var(--bs-yellow);

  &-wrapper {
    display: flex;
  }

  h2 {
    color: var(--bs-dark);
    font-size: 2rem;
    font-weight: normal;
    line-height: 1.2;
  }

  a {
    font-weight: bold;
    font-size: 2rem;
  }
}

.search-field {
  flex-direction: column;
  .autocomplete-search-input-wrapper {
    width: 100%;
    display: flex;
    justify-content: center;
  }
  .autocomplete-input {
    @media screen and (min-width: 768px) {
      width: 80%;
    }
  }
}

.two-column {
  .phone-information-wrapper {
    margin-bottom: 1.5rem;
  }

  @media screen and (min-width: 768px) {
    .phone-information-wrapper {
      margin-bottom: 0;
    }
  }
}

.extra-text {
  h2,
  a {
    font-size: 1.4rem;
  }
  h2 {
    margin-bottom: 0.25rem;
  }
}

.extra-text {
  .phone-information {
    text-align: center;
  }
}
</style>
